import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { CustomHeaderLink } from '@accredible-frontend-v2/models';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  extraHeaderLinks: AccredibleResponsiveMenuItem[];

  private _themeHeaderConfig: { customHeaderLinks: CustomHeaderLink[] } = {
    customHeaderLinks: [
      {
        label: 'certifications',
        link: 'https://productschool.com/product-management-certification/',
      },
      {
        label: 'our_instructors',
        link: 'https://productschool.com/instructor/',
      },
      {
        label: 'free_resources',
        link: 'https://productschool.com/free-product-management-resources/',
      },
      {
        label: 'online_event',
        link: 'https://productschool.com/product-management-events/',
      },
      {
        label: 'for_companies',
        link: 'https://productschool.com/corporate-training',
      },
    ],
  };

  constructor(private _t: AccredibleLanguageService) {
    this.extraHeaderLinks = this._createCustomHeaderLinks(
      this._themeHeaderConfig.customHeaderLinks,
    );
  }

  private _createCustomHeaderLinks(
    customLinkArray: { label: string; link: string }[],
  ): AccredibleResponsiveMenuItem[] {
    if (customLinkArray && customLinkArray.length > 0) {
      return customLinkArray.map((el, index) => {
        return {
          id: `custom-link-${index}`,
          label: this._t.selectTranslate(`directory_productschool_com.header.${el.label}`),
          externalLink: el.link,
        };
      });
    } else {
      return [];
    }
  }
}
